// extracted by mini-css-extract-plugin
module.exports = {"rotate90deg":"rotate90deg-R0fqj","reverse":"reverse-A0Pfb","rotate270deg":"rotate270deg-DLblN","spinner":"spinner-LcM5Y","rotating":"rotating-D4Ypu"};